<template>
  <v-layout wrap v-if="content">
    <v-flex xs12>
      <v-select
        v-model="content.RequestsCategoryID"
        item-text="Name"
        item-value="ID"
        :items="categories"
        label="Categor�a"
        outlined
        @change="handleChangeIsModified"
        hide-details
        style="margin-bottom: 10px;"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import utils from '@/services/utils'
export default {
  name: 'Form52Requests',
  components: {
  },
  props: {
    editedItem: {
      type: Object,
      required: true
    },
    onChangeIsModified: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    content: null,
    cmDviewcontentContentID: null,
    categories: null,
  }),
  computed: {        
    ...mapState('app', ['locale']),
    isNew () {
      return this.editedItem.ID === 'new'
    },
    languages () {
      return this.$store.state.app.languages
    },
    workspaceID () {
      return utils.getWorkspace('dtouch')
    },
  },
  watch: {
  },
  mounted () {
    this.prepareContent()
  },
  methods: {
    prepareContent () {
      this.content = JSON.parse(JSON.stringify(this.editedItem))
      api.getAll('dtouch', `v2/private/workspaces/${this.workspaceID}/requests-categories/`)
        .then(response => {
          response = response ? response.shift() : null
          response = response && response.Categories ? JSON.parse(response.Categories) : []
          response.unshift({ ID: null, Name: 'Todos' })
          this.categories = response
        })
    },
    handleChangeIsModified () {
      this.onChangeIsModified(this.content) 
    },
  },
}
</script>
<style scoped>
  .allergens-main {
    width: 100%;
  }
  .allergens-item {
    float: left;
    padding-right: 10px;
  }
</style>

